import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, css, frames, useMediaQuery } from "../../../../Styles";
import { PageHeader, Button, NewInput, GroupCard, NewInputHandles, NewModal, MainContentPaddingTypes, ButtonList, Overlay } from '../../../../Components';
import { ButtonTypes, ListStyle_Types } from '../../../../Definitions';
import { useAppSelector } from '../../../../Store';
import { Graph_QL } from '../../../../Services';
import { useAnimalGroups } from '../../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimalGroups';
import { Pages } from '../../../../Navigation/Routers/root';
import CardsView from '../../../../Assets/TestData/cardsView';
import { AnimalGroupInfo } from '../../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalGroupCall';

export default function AnimalsGroups() {
  const { t } = useTranslation();
  const [addGroupModal, setAddGroupModal] = useState<boolean>(false)
  const hideBtns = useMediaQuery(`(max-width: 600px)`);
  const hideBtnText = useMediaQuery(`(max-width: 450px)`);
  const [deleteGroupMode, setDeleteGroupMode] = useState(false)

  const animalGroupNameInputRef = useRef<NewInputHandles>(null);

  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;
  
  const { call: getAnimalGroups, data: animalGroupsState, maintainEntries: createAnimalGroups } = useAnimalGroups(connection);

  useEffect(() => {
    getAnimalGroups({fetchAmount: 50, ifIncludeAnimalCount: true})
  },[])

  const groupData = useMemo(() => {
    if (animalGroupsState && animalGroupsState[domain]) {
      return animalGroupsState[domain].data
    }
    return []
  },[animalGroupsState, domain])

  const addGroupModalComponent = (
    <NewModal
      modalState={!!addGroupModal}
      overrides={{ 
        mainContentPadding: MainContentPaddingTypes.secondary
      }}
      predefinedButtons={{
        onClose: () => setAddGroupModal(false)
      }}
      header={t("animalPages.animalGroups.newGroup", {defaultValue: "New Group"})}
      mainContent={
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "40px"}}>
          <NewInput ref={animalGroupNameInputRef} header={t("animalPages.animalGroups.groupName", {defaultValue: "group name"})}/>
          <Button
            content={t("animalPages.animalGroups.createGroup", {defaultValue: "create group"})}
            buttonType={ButtonTypes.primaryButton}
            overrides={{
              baseButton: {...css.button_FitContent}
            }}
            onClick={() => {
              if (animalGroupNameInputRef.current?.value && createAnimalGroups) {
                createAnimalGroups({data: [{name: animalGroupNameInputRef.current.value}]})
              }
              setAddGroupModal(false);
            }}
          />
        </div>
      }
    />
  )
  
  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between"}}>
          <PageHeader topHeader={t(`menuHeaders.${Pages.animals}`, {defaultValue: "animals"})} subHeader={t(`menuHeaders.${Pages.animalsGroups}`, {defaultValue: "animal groups"})}/>
            <div style={{display: "block", zIndex: "999999"}}>
            <ButtonList
              contents={deleteGroupMode ? ["save", t("buttons.cancel", {defaultValue: "cancel"})] : ["Delete group"]}
              onClick={deleteGroupMode 
                ? (i => { 
                  if (i === 0) {setDeleteGroupMode(false)}
                  if (i === 1) {setDeleteGroupMode(false)}
                  })
                : (i => { 
                  if (i === 0) {setDeleteGroupMode(true)}
                })
              }
              buttonType={ButtonTypes.primaryButton}
              overrides={{
                baseButton: { ...(!hideBtns ? { ...css.button_FitContent, minWidth: "none", backgroundColor: deleteGroupMode ? colors.greyPrimary : colors.greyDarkPrimary } : { backgroundColor: colors.greyDarkSecondary }) },
                hoverStyles: {...(!hideBtns ? { backgroundColor: deleteGroupMode ? colors.greySecondary : colors.blackPrimary } : { backgroundColor: colors.blackPrimary })}
              }}
              listOverrides={{
                listStyle: !hideBtns ? ListStyle_Types.horizontal : ListStyle_Types.vertical,
              }}
              responsiveOverrides={{
                isResponsive: !hideBtns ? false : true,
                popoverStyle: { backgroundColor: colors.greyDarkPrimary, padding: "20px", borderRadius: "10px", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d" },
                openContent: hideBtnText ? "" : "Options"
              }}
            />
            </div>
          </div>
      </frames._page_inner_header>
      <frames._page_inner_content_scroll>
        {deleteGroupMode ? <Overlay overrides={{ zIndex: 9999 }} /> : <></>}
        <div style={{ zIndex: deleteGroupMode ? "99999" : "auto", position: deleteGroupMode ? "relative" : "unset" }}>
          <CardsView
            data={groupData}
            card={(group, index) => <GroupCard key={index} selectedGroup={group} onClick={deleteGroupMode ? () => {} : undefined}/>}
            cardBtn={{
              content: t("animalPages.animalGroups.createGroup", {defaultValue: "create group"}),
              isCardBtnDisabled: deleteGroupMode,
              onCardBtnClick: () => { setAddGroupModal(true) },
              height: "50px"
            }}
          />
        </div>
      </frames._page_inner_content_scroll>
    
    {addGroupModalComponent}
    </frames.Page_inner>
  )
}